module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "maestro.9b1c5111.png";